import { defineComponent as _defineComponent } from 'vue'
import state from "../state/state";

export default /*#__PURE__*/_defineComponent({
  __name: 'InfantClubContent',
  setup(__props) {


return { __sfc: true,state }
}

})